import { FormBase } from "../form-base-form";

class SpinnerForm extends FormBase {
    public getEventForm(event: Event): HTMLFormElement | null {
        return this.fromEventTarget(event, HTMLFormElement);
    }

    public getSubmitButton(root: ParentNode): HTMLButtonElement | HTMLInputElement | null {
        const button = this.queryElement(root, 'button[type="submit"]', HTMLButtonElement);
        if (button) return button;
        return this.queryElement(root, 'input[type="submit"]', HTMLInputElement);
    }

    public getEventTarget(event: Event): Element | null {
        return this.fromEventTarget(event, Element);
    }

    public getClosestLink(element: Element | null | undefined): HTMLAnchorElement | null {
        return this.closest(element, "a[href]", HTMLAnchorElement);
    }
}

const spinnerForm = new SpinnerForm();

export { SpinnerForm, spinnerForm };
